<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ion-page>
 
      <IndexPage />
      <!-- <VoiceCall/> -->
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,

  
} from '@ionic/vue'



</script>
